import { render, staticRenderFns } from "./DonutExpenseByHub.vue?vue&type=template&id=c3b183d2&lang=pug&"
import script from "./DonutExpenseByHub.vue?vue&type=script&lang=ts&"
export * from "./DonutExpenseByHub.vue?vue&type=script&lang=ts&"
import style0 from "./DonutExpenseByHub.vue?vue&type=style&index=0&id=c3b183d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports